export const mentionMarkupRegex = /@\[(.*?)\]\(userId:\d+\)/g;

export const buildMentionMarkup = (name, userId) => `@[${name}](userId:${userId})`;

export const replaceMentionMarkupWithNames = (text = '') =>
  String(text).replace(mentionMarkupRegex, '@$1');

export const stripHtmlTagsFromText = (text = '') =>
  String(text)
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>\s*<p>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .trim();

export const getMentionPlainText = (text = '') => {
  if (typeof text !== 'string') {
    return '';
  }

  let parsedText = text;

  if (parsedText.startsWith('"') && parsedText.endsWith('"')) {
    try {
      parsedText = JSON.parse(parsedText);
    } catch (error) {
      parsedText = text;
    }
  }

  return replaceMentionMarkupWithNames(parsedText);
};

export const getNotificationPlainText = (text = '') =>
  stripHtmlTagsFromText(getMentionPlainText(text));
